import * as React from "react";
import { useState } from "react";
import { ResultPageModel } from "../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { ExternalAsset } from "../../../../../Wrap/Models/Domains/Investment/ExternalAsset";
import { Investment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentDetailsPopupModal } from "../../../../Dashboard/Components/Clients/Common/InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { Table } from "../../../Table/Table";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
interface IOffPlatformResultsProps {
    data: ResultPageModel<ExternalAsset>;
    allocationTable: any[];
    onPageChange: (pageIndex) => void;
    index: number;
}
export const OffPlatformResults = (props: IOffPlatformResultsProps) => {
    const [isShowDetailModal, setShow] = React.useState(false);
    const [selectedInvestment, setSelected] = React.useState<Investment>(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState<ResultPageModel<ExternalAsset>>(null);

    const onInvestmentSelected = (investment) => {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            setSelected(d);
            setShow(true);           
        });
    };

    React.useEffect(() => {
        const _data = JSON.parse(JSON.stringify(props.data));
        _data.Results = props.data.Results.map((ele) => {
            const isSelected = props.allocationTable?.some(
                (item) => item.Instrument?.ProductId == ele.ProductId || item.Investment?.ProductId == ele.ProductId
            );
            return { ...ele, isSelected: isSelected };
        });

        setData(_data);
    }, [props.allocationTable]);

    React.useEffect(() => {
        const _data = JSON.parse(JSON.stringify(props.data));
        _data.Results = props.data.Results.map((ele) => {
            const isSelected = props.allocationTable?.some(
                (item) => item.Instrument?.ProductId == ele.ProductId || item.Investment?.ProductId == ele.ProductId
            );
            return { ...ele, isSelected: isSelected };
        });
        setData(_data);
    }, [props.data]);
    const renderInvestmentDetailPopupModal = (): JSX.Element => {
        if (!isShowDetailModal) return null;
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        setShow(false);
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    };

    return (
        <div className="panel pr-0 pl-0 pb-0 pt-0 mt-40">
            <h3>{"Selection"}</h3>
            <p>Funds available: {props.data.Pager.TotalRecords}</p>
            <Table
                data={data?.Results}
                cssWrapper={"no-sided-padding"}
                showEmptyMsg
                cssEmptyMessage="warning-message mt-20"
                needPagination={{
                    totalNumOfResult: props.data.Pager.TotalRecords,
                    currentPage: currentPage,
                    onPaginationChange: (pageIndex) => {
                        setCurrentPage(pageIndex);
                        props.onPageChange(pageIndex);
                    },
                }}
                col={[
                    {
                        title: "Fund name",
                        key: "Name",
                        render: (rowData, row) => {
                            return (
                                <a className="hyperlink" onClick={() => onInvestmentSelected(row)}>
                                    {rowData}
                                </a>
                            );
                        },
                    },
                    {
                        title: <span className="sr-only">select an investment</span>,
                        key: "isSelected",
                        render: (data, row) => {
                            return (
                                <a
                                    className={"select-toggle"}
                                    onClick={() => {
                                        if (data) return null;
                                        if (props.index) {
                                            InvestmentSelectionAction.setEditingTransferNumber(props.index);
                                        }
                                        InvestmentSelectionAction.addInvestment(row);
                                        onInvestmentSelected(row)
                                    }}
                                    aria-pressed={data}
                                >
                                    <span className="label">{data ? "Added" : "Select"}</span>
                                </a>
                            );
                        },
                    },
                ]}
            />
            {renderInvestmentDetailPopupModal()}
        </div>
    );
};
